import React, { useContext } from 'react';

import { AppContext } from 'contexts';
import { makeStyles, Box, Modal, Typography, Button } from '@material-ui/core';
import { AgoraRTCClient } from 'utils/agora';

const useStyles = makeStyles((theme) => {
  return {
    hangupModal: {
      width: 300,
      position: 'relative',
      top: '20%',
      marginLeft: 'auto',
      marginRight: 'auto',
      alignContent: 'center',
      backgroundColor: 'white',
      padding: 30,
      animation: 'slide-down .2s ease-in',
      '@media (max-width: 767px)': {
        top: 101,
      },
    },
    cancelButton: {
      marginRight: 20,
    },
    title: {
      marginBottom: 20,
    },
    button: {
      marginRight: 20,
    },
  };
});
function HangupModal() {
  const appContext = useContext(AppContext);
  const classes = useStyles();
  const {
    listing,
    sendDataToVRServer,
    setCallOngoing,
    displayHangupModal,
    setDisplayHangupModal,
    setIsJoinedSession,
    sessionId,
    stopRinging,
    isJoinedSession,
    ringtone,
  } = appContext;
  const broker = listing ? listing.broker : null;
  return (
    <div>
      <Modal
        open={displayHangupModal}
        onClose={() => {
          setDisplayHangupModal(false);
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box className={classes.hangupModal}>
          <Typography className={classes.title}>Êtes-vous prêt à raccrocher?</Typography>
          <Button
            className={classes.cancelButton}
            variant='contained'
            size='small'
            onClick={() => {
              setDisplayHangupModal(false);
            }}
          >
            Annuler
          </Button>
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={() => {
              setDisplayHangupModal(false);
              setCallOngoing(false);
              setIsJoinedSession(false);
              ringtone.stop();
              AgoraRTCClient.leave();
              if (!isJoinedSession) {
                stopRinging(broker.id, sessionId);
                return;
              }
              sendDataToVRServer({ type: 'session-leave', content: null });
            }}
          >
            Raccrocher
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
export default HangupModal;
